import React from 'react';
import CustomCells from 'ui/structure/CustomTableCells/CustomCells';
import noop from 'utils/noop';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './ScheduledTransfers.module.css';

import Edit from 'assets/icons/edit.svg';
import Trash from 'assets/icons/trash.png';

export interface IColumn {
  Header: string;
  accessor: string;
  width: number
}

const defaultColumns = [
  {
    Header: 'Schedule ID',
    accessor: 'scheduleId',
    width: 120,
  },
  {
    Header: 'Source Account',
    accessor: 'sourceAccount',
    width: 100,
    Cell: ({ row: { original: { sourceAccount, accountType } } }) => (
      <CustomCells>
        <div className={styles.cellContainer}>
          <span className={styles.tableTitle}>{sourceAccount}</span>
          <span className={styles.tableSubTitle}>{accountType}</span>
        </div>
      </CustomCells>
    ),
  },
  {
    Header: 'Beneficiary',
    accessor: 'beneficiary',
    width: 120,
    Cell: ({ row: { original: { destinationAccountNo, destinationAccountName } } }) => (
      <CustomCells>
        <div className={styles.cellContainer}>
          <span className={styles.tableTitle}>{destinationAccountNo}</span>
          <span className={styles.tableSubTitle}>{destinationAccountName}</span>
        </div>
      </CustomCells>
    ),
  },
  {
    Header: 'Beneficiary Bank',
    accessor: 'beneficiaryBank',
    width: 120,
  },
  {
    Header: 'Transfer Type',
    accessor: 'transferType',
    width: 120,
  },
  {
    Header: 'Total Beneficiaries',
    accessor: 'totalBeneficiaries',
    width: 120,
  },
  {
    Header: 'Amount',
    accessor: 'transactionAmount',
    width: 120,
    Cell: ({ row: { original: { transactionAmount } } }) => (
      <CustomCells>
        <span>{`GHS ${Number(transactionAmount).toFixed(2)}`}</span>
      </CustomCells>
    ),
  },
  {
    Header: 'Charges',
    accessor: 'charges',
    width: 120,
  },
  {
    Header: 'Total Amount',
    accessor: 'totalAmount',
    width: 120,
  },
  {
    Header: 'Narration',
    accessor: 'transactionNarration',
    width: 120,
  },
  {
    Header: 'Frequency',
    accessor: 'frequency',
    width: 120,
    Cell: ({ row: { original: { frequency, specialDate } } }) => (
      <CustomCells>
        <div className={styles.cellContainer}>
          <span className={styles.tableTitle}>{frequency}</span>
          <span className={styles.tableSubTitle}>{specialDate}</span>
        </div>
      </CustomCells>
    ),
  },
  {
    Header: 'Created',
    accessor: 'created',
    width: 120,
    Cell: ({ row: { original: { initiator, createDate } } }) => (
      <CustomCells>
        <div className={styles.cellContainer}>
          <span className={styles.tableTitle}>{initiator}</span>
          <span className={styles.tableSubTitle}>{createDate}</span>
        </div>
      </CustomCells>
    ),
  },
  {
    Header: 'Final Approval',
    accessor: 'finalApproval',
    width: 120,
    Cell: ({ row: { original: { approver, dateApproved } } }) => (
      <CustomCells>
        <div className={styles.cellContainer}>
          <span className={styles.tableTitle}>{approver}</span>
          <span className={styles.tableSubTitle}>{dateApproved}</span>
        </div>
      </CustomCells>
    ),
  },
  {
    Header: 'Edit',
    accessor: 'edit',
    width: 60,
    Cell: ({ row }) => (
      <div onKeyPress={noop} role="button" onClick={() => console.log(row)} tabIndex={0} className={styles.pointer}>
        <img src={Edit} alt="delete icon" />
      </div>
    ),
  },
  {
    Header: 'Delete',
    accessor: 'delete',
    width: 60,
    Cell: ({ row }) => (
      <div onKeyPress={noop} role="button" onClick={() => console.log(row)} tabIndex={0} className={styles.pointer}>
        <img src={Trash} alt="delete icon" className={styles.trashIcon} />
      </div>
    ),
  },
];


const allColumns = {
  defaultColumns,
};

export default allColumns;
